package com.klantenstop.web.data.models.dto.requests.company

import com.klantenstop.web.data.models.domain.Status
import com.klantenstop.web.data.models.dto.requests.address.InsertAddress
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class InsertCompany(
    val name: String,
    val description: String? = null,
    val categories: List<String> = emptyList(),
    val address: InsertAddress,
    val verified: Boolean = false,
    @SerialName("phone_number")
    val phoneNumber: String? = null,
    @SerialName("email_address")
    val emailAddress: String? = null,
    val website: String? = null,
    val status: InsertCompanyStatus
) {
    val isValid
        get() = name.isNotBlank() && address.isValid && status.isValid
}

@Serializable
data class InsertCompanyStatus(
    val text: String = "",
    val status: Status.Type = Status.Type.Unknown,
) {
    val isValid
        get() = text.isNotBlank()
}
